import microuniversoApi from "app/api/microuniversoApi";
import store from "app/redux/store/store";
import { IOrcamento } from "app/types/IOrcamento";
import { WindowMU } from "app/types/WindowMU";
import * as R from 'ramda'

declare var window:WindowMU

export async function excluirParcelas(codigosParcelas:number[]) {
    await microuniversoApi.Orcamento.excluirParcelas(store.getState().orcamento.IdentificadorOrcamento,
    codigosParcelas)

    // const parcelasNaoExcluidas = store.getState().orcamento.ParcelasFormaPagamento.filter(p => !R.includes(p.Codigo, codigosParcelas))

    // const orcamentoSemParcelasExcluidas = {
    //     ...store.getState().orcamento,
    //     ParcelasFormaPagamento: parcelasNaoExcluidas
    // } as IOrcamento

    // window.orcamentoController.model.atualizar(orcamentoSemParcelasExcluidas, true, true)


}